<template>
  <div>
    <el-button @click="Leave" type="primary">Leave</el-button>
    <div class="list" :class="`list${index}`"></div>
  </div>
</template>
<script>
import AgoraRTC from "agora-rtc-sdk-ng";
import $ from "jquery";
export default {
  data() {
    return {
      appid: window.atob("a2pjYXNvOWJkZWM0YWVjMWQ5NGVhMTg3NmQ3NWQxYmFkMGY3Yjc").slice(6),
      agoraClient: null,
      remoteUsers: {},
      uid: "",
      UserTaracks: {
        videoTrack: null,
        audioTrack: null,
      },
    };
  },
  props: {
    channel: {
      type: String,
    },
    index: {
      type: Number,
    },
  },
  activated() {
    this.Leave();
    this.sharRTC();
  },
  mounted() {
    this.sharRTC();
  },
  methods: {
    sharRTC() {
      // 创建本地客户端 AgoraRTC 的实例
      this.agoraClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      // 连接
      this.join();
    },
    // 获取
    async join() {
      // 添加事件侦听器以在远程用户发布时播放远程曲目.
      this.agoraClient.on("user-published", this.handleUserPublished);
      this.agoraClient.on("user-unpublished", this.handleUserUnpublished);

      let dates = new Date();
      let times = dates.getTime().toString().substr(-6);
      this.uid = 1000 + this.index + times;
      [this.uid] = await Promise.all([
        // join the channel
        this.agoraClient.join(this.appid, this.channel, null, parseInt(this.uid)),
      ]);
    },
    handleUserPublished(user, mediaType) {
      const id = user.uid;
      this.remoteUsers[id] = user;
      this.subscribe(user, mediaType);
    },
    handleUserUnpublished(user) {
      const id = user.uid;
      delete this.remoteUsers[id];
    },
    async subscribe(user, mediaType) {
      const uid = user.uid;
      // 订阅远程用户
      await this.agoraClient.subscribe(user, mediaType);

      if (mediaType === "video") {
        const player = $(`
          <div id="player-wrapper-${uid}">
            <p class="player-name">remoteUser(${uid})</p>
            <div id="player-${uid}" class="player"></div>
          </div>
        `);
        const div = $(`<div id = 'remote-playerlist' class='playerlist'></div>`);
        div.append(player);
        $(`.list${this.index}`).append(div);
        try {
          user.videoTrack.play(`player-${uid}`);
          user.audioTrack.play();
        } catch (error) {}

        this.UserTaracks.audioTrack = user.audioTrack;
        this.UserTaracks.videoTrack = user.videoTrack;
      }
      if (mediaType === "audio") {
        user.audioTrack.play();
      }
    },
    // 客户离开信道
    async Leave() {
      this.remoteUsers = {};
      $(`.list${this.index}`).html("");
      await this.agoraClient.leave();
      this.UserTaracks.videoTrack && this.UserTaracks.videoTrack.close();
      this.UserTaracks.audioTrack && this.UserTaracks.audioTrack.close();
    },
  },
  async destroyed() {
    this.Leave();
  },
};
</script>
<style lang="scss" scoped>
.list {
  display: flex;
  margin-bottom: 20px;
  ::v-deep .player {
    width: 400px;
    height: 640px;
    margin: 10px 10px 10px 0;
  }
}
.playerlist {
  width: 500px;
  height: auto;
  display: flex;
}
</style>
